import createIcon from '../../createIcon';

/**
 * @component @name SettingsOverscan
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuMDEgNS41TDEwIDhIMTRMMTIuMDEgNS41Wk0xOCAxMFYxNEwyMC41IDEyLjAxTDE4IDEwWk02IDEwTDMuNSAxMi4wMUw2IDE0VjEwWk0xNCAxNkgxMEwxMi4wMSAxOC41TDE0IDE2Wk0yMSAzSDNDMS45IDMgMSAzLjkgMSA1VjE5QzEgMjAuMSAxLjkgMjEgMyAyMUgyMUMyMi4xIDIxIDIzIDIwLjEgMjMgMTlWNUMyMyAzLjkgMjIuMSAzIDIxIDNaTTIxIDE5LjAxSDNWNC45OUgyMVYxOS4wMVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SettingsOverscan = createIcon('SettingsOverscan', [
  [
    'path',
    {
      d: 'M12.01 5.5L10 8H14L12.01 5.5ZM18 10V14L20.5 12.01L18 10ZM6 10L3.5 12.01L6 14V10ZM14 16H10L12.01 18.5L14 16ZM21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM21 19.01H3V4.99H21V19.01Z',
      key: '50u2r3',
    },
  ],
]);

export default SettingsOverscan;
